export default "dist/images/components-columns-width-control-2-2-grid.7639d58.png";